/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertRfiConfig,
    InternalApiAlertRfiConfigFromJSON,
    InternalApiAlertRfiConfigToJSON,
} from '../models';

export interface UpdateAlertRfiConfigRequest {
    alertRfiId: string;
    internalApiAlertRfiConfig: InternalApiAlertRfiConfig;
}

/**
 * 
 */
export class AlertRfiConfigInternalApi extends runtime.BaseAPI {

    /**
     * Update alert RFI config
     */
    async updateAlertRfiConfigRaw(requestParameters: UpdateAlertRfiConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.alertRfiId === null || requestParameters.alertRfiId === undefined) {
            throw new runtime.RequiredError('alertRfiId','Required parameter requestParameters.alertRfiId was null or undefined when calling updateAlertRfiConfig.');
        }

        if (requestParameters.internalApiAlertRfiConfig === null || requestParameters.internalApiAlertRfiConfig === undefined) {
            throw new runtime.RequiredError('internalApiAlertRfiConfig','Required parameter requestParameters.internalApiAlertRfiConfig was null or undefined when calling updateAlertRfiConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alert-rfi/{alertRfiId}/config`.replace(`{${"alertRfiId"}}`, encodeURIComponent(String(requestParameters.alertRfiId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertRfiConfigToJSON(requestParameters.internalApiAlertRfiConfig),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update alert RFI config
     */
    async updateAlertRfiConfig(requestParameters: UpdateAlertRfiConfigRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateAlertRfiConfigRaw(requestParameters, initOverrides);
    }

}
